import { render, staticRenderFns } from "./1001.vue?vue&type=template&id=394caaa0&scoped=true&"
import script from "./1001.vue?vue&type=script&lang=js&"
export * from "./1001.vue?vue&type=script&lang=js&"
import style0 from "./1001.vue?vue&type=style&index=0&id=394caaa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394caaa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
